var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 52,
    viewBox: "0 0 32 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4458 49.5693C28.2434 50.581 23.1341 51.441 16.9119 51.4916C10.5885 51.5422 5.22628 50.7833 5.02393 49.6704C4.97334 49.4175 3.30396 45.067 3.30396 45.067L29.9634 45.0164C29.9634 45.0164 28.4964 49.3163 28.4458 49.5693Z",
    fill: "url(#paint0_linear_675_3432)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2859 45.067C22.3247 47.1411 22.2235 49.2657 17.873 51.4916C23.64 51.3904 28.294 50.5304 28.4458 49.5693C28.4963 49.3163 29.9634 45.0164 29.9634 45.0164L23.2859 45.067Z",
    fill: "#772781"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9635 44.9658C29.7106 46.1799 23.893 47.1917 16.8108 47.1917C9.67803 47.2422 3.60757 46.2811 3.30405 45.0164C2.94994 43.7012 9.0204 42.5882 16.7602 42.5882C24.3483 42.5882 30.2164 43.7012 29.9635 44.9658Z",
    fill: "url(#paint1_linear_675_3432)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.508 44.3082C28.041 43.347 22.9823 42.5882 16.7601 42.5882C12.3084 42.5882 8.41319 42.9929 5.93442 43.5494C5.58031 44.46 5.02385 44.7129 6.0356 45.067C7.04734 45.4717 22.0717 47.394 29.508 44.3082Z",
    fill: "#772781"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18741 44.3588C5.98506 44.4093 4.87214 44.814 5.12508 44.9658C5.4286 45.1682 8.16031 46.3822 15.546 46.3822C22.9318 46.3822 27.7375 45.1682 27.8387 44.8646C27.9905 44.5611 11.8026 43.7011 6.18741 44.3588Z",
    fill: "#772781"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.726 19.7228C29.1542 17.0417 29.7612 6.97485 29.7612 6.97485L2.84888 7.32897C2.84888 7.32897 3.40535 16.6876 5.53001 19.5711C7.65467 22.5557 9.93108 23.2639 11.1958 24.2251C12.511 25.1356 12.4098 27.6144 11.3981 29.0309C10.6899 30.0426 5.58059 31.9143 4.51826 35.1013C3.45593 38.3389 5.63117 44.8646 5.63117 44.8646C11.6005 46.4834 20.4026 46.3317 27.2319 44.8646C27.2319 44.8646 28.3448 38.6424 27.9907 35.1013C27.7378 32.8755 21.5155 30.2449 19.7956 29.2332C18.0756 28.2215 18.0756 25.4392 19.6944 24.5286C21.2626 23.6686 24.652 21.9992 26.726 19.7228Z",
    fill: "url(#paint2_linear_675_3432)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M28.0919 9.20067C28.0919 9.20067 26.7261 18.104 26.979 18.104C27.0802 18.104 27.8896 16.9405 28.3448 15.2206C29.0025 12.6406 29.3566 9.15009 29.4072 8.64422C29.4578 7.78424 28.0919 9.20067 28.0919 9.20067Z",
    fill: "url(#paint3_linear_675_3432)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M3.25342 8.54307C3.25342 8.54307 3.86046 15.4735 4.72044 17.2946C5.58042 19.0652 6.49099 19.0652 6.49099 19.0652C6.49099 19.0652 5.22631 16.2829 4.8722 13.6524C4.4675 10.9713 4.66985 8.34072 4.66985 8.34072L3.25342 8.54307Z",
    fill: "url(#paint4_linear_675_3432)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5651 22.4546C9.57684 23.1122 10.6898 23.6181 11.6003 24.4275C13.0674 25.7933 12.258 27.918 11.7521 28.8285C11.5497 29.1827 11.0944 29.5368 10.6897 29.7897C10.1333 30.1944 12.6121 29.5873 13.4215 27.9686C13.725 27.1592 13.8767 25.2874 13.3709 24.7816C12.8144 24.2757 7.95805 22.0499 8.5651 22.4546Z",
    fill: "#772781"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.605 22.8592C20.4026 22.6063 17.9239 24.2757 17.418 24.9333C16.9627 25.591 16.4063 27.1592 17.0639 28.2721C17.7215 29.3344 19.8462 29.7391 20.3015 29.7897C20.7567 29.8909 19.0874 29.3344 18.5815 28.3227C17.9745 27.2097 17.9239 25.6415 19.0874 24.7816C20.2509 23.871 20.7567 23.0616 20.605 22.8592Z",
    fill: "#772781"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M4.97331 8.84659C4.97331 9.04894 4.61919 15.6253 6.89561 18.964C9.17204 22.3028 13.7249 23.7698 13.8767 25.4898C13.9778 27.2097 13.8261 28.2721 12.8649 29.2332C11.9543 30.245 7.04737 32.8249 5.83328 34.646C4.61919 36.4672 6.74385 42.9929 7.3509 43.9541C8.41323 45.4211 24.0447 45.674 25.3599 44.46C26.7258 43.2459 27.2823 36.366 26.5234 34.7472C25.7646 33.0778 18.733 30.3461 17.7213 29.4861C16.2036 28.1709 15.8495 25.8945 18.3283 24.0227C19.5424 23.0616 24.7023 20.0769 25.8658 18.4581C27.0799 16.7888 27.9905 8.59365 27.9905 8.59365L4.97331 8.84659Z",
    fill: "url(#paint5_linear_675_3432)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M6.44029 41.6271C6.7944 42.74 7.1485 43.6506 7.35085 43.9541C8.41318 45.4211 24.0446 45.6741 25.3599 44.46C25.8658 43.9541 26.2705 42.6894 26.5234 41.2224C26.7257 40.0083 20.4529 33.179 15.3436 33.3308C10.1332 33.432 6.08618 40.4636 6.44029 41.6271Z",
    fill: "url(#paint6_linear_675_3432)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9788 14.2594C26.7259 13.3994 20.706 11.7301 15.0909 12.2865C10.4368 12.7418 5.68164 15.2712 5.68164 15.6759C5.78281 16.4853 6.64279 19.0652 8.66628 20.6334C10.6898 22.2016 12.5109 23.1628 13.725 24.6298C14.8885 26.0462 15.0403 35.2025 15.0403 35.6072C15.192 40.16 15.6979 37.1754 15.5967 35.3037C15.5461 33.4825 15.3944 26.805 17.4684 24.6298C19.5931 22.4039 24.3483 19.9758 25.4612 18.6099C26.5236 17.2441 27.08 14.31 26.9788 14.2594Z",
    fill: "url(#paint7_linear_675_3432)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68164 15.6759C9.27333 21.7463 21.6166 20.7346 26.9788 14.2594C26.7259 13.3994 20.706 11.7301 15.0909 12.2865C10.4368 12.7418 5.68164 15.2712 5.68164 15.6759Z",
    fill: "url(#paint8_linear_675_3432)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4072 10.4148C29.6601 8.44189 29.7612 6.97485 29.7612 6.97485L2.84888 7.32897C2.84888 7.32897 2.95006 8.79599 3.20299 10.7183C10.9934 15.0688 22.2744 15.3217 29.4072 10.4148Z",
    fill: "#9A376D"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7224 8.23955C30.3177 9.55482 24.1967 10.7689 16.0521 10.7689C7.95819 10.7689 1.38185 9.6054 1.38185 8.23955C1.38185 7.83485 0.623047 3.28201 0.623047 3.28201H31.5318C31.5318 3.28201 31.1777 6.8737 30.7224 8.23955Z",
    fill: "url(#paint9_linear_675_3432)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22998 4.04081C1.22998 4.04081 2.84876 6.72193 8.61569 7.32898C14.3826 7.98661 23.3872 5.76077 23.4377 5.55842C23.5389 4.8502 1.63468 3.02907 1.22998 4.04081Z",
    fill: "#78617A"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M1.22998 3.99021C1.22998 3.99021 3.30405 5.5584 9.32393 5.9631C15.3438 6.31721 23.1848 5.55841 23.1848 5.55841C23.1848 5.55841 12.1062 3.53492 8.51453 3.28199C4.87225 3.07964 1.22998 3.99021 1.22998 3.99021Z",
    fill: "url(#paint10_linear_675_3432)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.247 3.28201C23.7412 6.11489 22.2235 8.79601 20.0989 10.6172C26.1188 10.3136 30.4187 9.35247 30.7222 8.23955C31.1775 6.8737 31.5316 3.28201 31.5316 3.28201H24.247Z",
    fill: "#772781"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5318 3.28197C31.5318 4.24312 28.2436 5.1031 23.3873 5.5078C21.212 5.71015 8.61583 3.38314 1.2301 3.99019C0.825402 3.78784 0.623047 3.55177 0.623047 3.28197C0.623047 1.91611 7.55349 0.803192 16.0521 0.803192C24.6014 0.803192 31.5318 1.91611 31.5318 3.28197Z",
    fill: "url(#paint11_linear_675_3432)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65439 44.0047C7.65439 44.0047 9.27317 44.8141 15.4448 45.0164C21.667 45.2694 24.5505 44.6623 25.107 44.3082C25.6634 43.9541 20.7565 39.6542 15.3942 39.6036C10.8414 39.6036 7.50262 42.5882 7.65439 44.0047Z",
    fill: "url(#paint12_linear_675_3432)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1614 41.1212C11.8028 47.0399 8.96993 42.8918 8.61582 42.2341C7.95819 42.8918 7.60408 43.5494 7.65467 44.0047C7.65467 44.0047 9.27346 44.8141 15.4451 45.0164C21.6673 45.2694 24.5508 44.6623 25.1072 44.3082C25.4614 44.1059 23.7414 42.3859 21.1614 41.1212Z",
    fill: "#E09590"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M21.3636 30.0932C20.7059 29.7391 20.1495 29.4861 19.7954 29.2332C18.0754 28.2215 18.0754 25.4392 19.6942 24.5286C21.1612 23.7192 24.2976 22.151 26.3717 20.0769C19.6436 22.6063 12.8649 22.7581 5.52979 19.6217C7.65445 22.5557 9.93086 23.2639 11.1955 24.2251C12.5108 25.1357 12.4096 27.6144 11.3979 29.0309C11.1955 29.2838 10.6391 29.6379 9.98145 30.0932C13.9272 28.2215 17.6707 28.5756 21.3636 30.0932Z",
    fill: "url(#paint13_linear_675_3432)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46777 39.8565C4.87247 42.4871 5.63127 44.8647 5.63127 44.8647C11.6006 46.4834 20.4027 46.3317 27.232 44.8647C27.232 44.8647 27.6367 42.5882 27.8896 40.0083C27.4849 41.7283 26.7767 43.2459 25.8661 44.1058C23.8427 46.0282 20.7062 45.9776 14.1805 45.5729C4.82187 44.9658 6.54185 45.0164 4.46777 39.8565Z",
    fill: "#772781"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35474 44.7635C3.35474 44.7635 5.1253 46.1799 11.3475 46.7364C17.5697 47.2928 27.9907 46.1799 27.9907 46.1799C27.9907 46.1799 16.9121 47.7481 10.8416 47.0905C4.7206 46.4329 3.35474 44.7635 3.35474 44.7635Z",
    fill: "#FFFFB3"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.651 31.1049C10.8922 31.4085 5.88403 34.646 6.84519 35.5566C7.80635 36.4166 10.5381 34.646 11.0945 33.6343C11.651 32.6731 11.9039 31.0038 11.651 31.1049Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79449 33.5837C6.84507 33.6849 11.0944 30.6497 11.0944 30.5991C11.0944 30.5485 9.42501 31.6108 8.46386 32.1673C7.55329 32.7743 6.7439 33.5331 6.79449 33.5837Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10969 13.0453C4.97328 13.3994 7.24971 18.5087 8.51439 18.6099C9.72849 18.7111 11.2461 12.6406 8.10969 13.0453Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8,
    d: "M17.6707 24.5792C17.6707 24.5792 19.0365 23.5675 20.6047 22.5051C21.92 21.5946 23.4376 20.684 23.9435 20.2793C25.0564 19.4699 25.3093 19.4699 26.0681 18.2052C26.8269 16.9405 27.7881 10.9207 27.7881 10.9207C27.7881 10.9207 27.0799 15.9794 25.6634 18.104C24.9552 19.217 22.6282 20.8863 20.7565 22.2522C18.9859 23.5675 17.6707 24.5792 17.6707 24.5792Z",
    fill: "url(#paint14_linear_675_3432)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8,
    d: "M4.97363 10.9712C4.97363 10.9712 5.12539 15.4229 6.69359 18.0029C8.71708 21.3416 11.9547 23.3651 11.9547 23.3651C11.9547 23.3651 8.66649 21.5946 6.59241 18.4581C5.27715 16.5358 4.97363 10.9712 4.97363 10.9712Z",
    fill: "url(#paint15_linear_675_3432)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M5.83367 34.646C7.55364 33.6849 12.41 34.2413 13.8265 36.2648C15.2429 38.2377 18.0758 45.5223 17.2158 45.5223C16.4064 45.5223 6.23837 45.5223 5.83367 44.5105C5.47956 43.4482 4.1643 35.5566 5.83367 34.646Z",
    fill: "url(#paint16_linear_675_3432)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M4.11353 10.9712C4.11353 10.9712 4.72058 17.5982 7.75581 20.3299C10.791 23.011 14.9392 22.8086 17.165 22.2016C19.3909 21.6451 19.9979 13.7029 19.1379 13.2477C18.2274 12.843 5.47938 11.0218 4.11353 10.9712Z",
    fill: "url(#paint17_linear_675_3432)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3599 34.646C24.6517 34.4943 24.5505 35.8095 25.0564 35.8601C25.5117 35.9107 26.6752 34.899 25.3599 34.646Z",
    fill: "#FFFDFF"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0556 29.6885C12.5109 29.2838 13.725 28.2721 13.0673 28.1203C12.4097 27.9685 11.5497 30.0426 12.0556 29.6885Z",
    fill: "#FFFDFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14887 37.2766C6.13713 37.5801 7.35122 39.0471 7.95827 38.946C8.51473 38.8448 8.46414 36.8719 7.14887 37.2766Z",
    fill: "#FFFDFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2082 2.47261C22.0212 2.06792 8.56504 2.5232 18.2272 3.58553C27.8893 4.69845 29.3564 2.97849 25.2082 2.47261Z",
    fill: "#4F2A6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0249 3.58553C8.7675 2.5232 22.0719 2.06792 25.2083 2.47261C26.1189 2.57379 26.7765 2.77613 27.1306 2.9279C23.7413 2.77613 17.0638 3.02907 18.0249 3.58553Z",
    fill: "#4F2A6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4134 1.91615C6.74402 1.91615 0.0159404 2.67495 7.04756 2.82672C14.0792 3.02906 10.5381 1.91615 8.4134 1.91615Z",
    fill: "#4F2A6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8922 2.27026C10.6561 2.27026 10.4369 2.27026 10.2346 2.27026C9.22284 2.27026 6.38995 2.52319 5.83349 2.82672C0.926535 2.57378 6.84524 1.91615 8.41344 1.91615C9.27342 1.91615 10.3357 2.06791 10.8922 2.27026Z",
    fill: "#4F2A6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_675_3432",
    x1: 28.2601,
    y1: 64.9847,
    x2: 9.46437,
    y2: 44.6027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F3A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_675_3432",
    x1: 14.6882,
    y1: 63.4737,
    x2: 15.9291,
    y2: 46.7212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#776783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_675_3432",
    x1: 44.7067,
    y1: 5.6262,
    x2: 44.7067,
    y2: 53.1842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9082A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#E1DDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9082A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_675_3432",
    x1: 48.1812,
    y1: 14.7405,
    x2: 45.8496,
    y2: 25.5889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#772781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_675_3432",
    x1: 23.0234,
    y1: 7.19239,
    x2: 22.6858,
    y2: 16.1215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#772781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_675_3432",
    x1: 44.0928,
    y1: -19.0674,
    x2: 47.8342,
    y2: 50.2178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9082A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_675_3432",
    x1: 19.5019,
    y1: 23.8376,
    x2: 20.786,
    y2: 47.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9082A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_675_3432",
    x1: 33.8445,
    y1: 9.26848,
    x2: 32.0769,
    y2: 37.9246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_675_3432",
    x1: 5.70643,
    y1: 12.1535,
    x2: 26.9874,
    y2: 12.1535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_675_3432",
    x1: 27.5187,
    y1: 29.5296,
    x2: 10.6311,
    y2: 3.83958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F3A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_675_3432",
    x1: 9.85155,
    y1: 21.2718,
    x2: 13.4998,
    y2: -8.69553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#776783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_675_3432",
    x1: 15.7051,
    y1: 18.7434,
    x2: 15.7051,
    y2: -0.638543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#776783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_675_3432",
    x1: 17.6889,
    y1: 38.3586,
    x2: 17.2626,
    y2: 45.2668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_675_3432",
    x1: 19.0497,
    y1: 20.5545,
    x2: 18.5125,
    y2: 31.5648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_675_3432",
    x1: 17.6929,
    y1: 10.9353,
    x2: 27.7694,
    y2: 10.9353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8CCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_675_3432",
    x1: 4.95896,
    y1: 10.9672,
    x2: 11.9435,
    y2: 10.9672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8CCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_675_3432",
    x1: 16.3674,
    y1: 51.8361,
    x2: 16.4631,
    y2: 34.8782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#008DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#FFAB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_675_3432",
    x1: -5.54509,
    y1: 22.4454,
    x2: 12.6078,
    y2: 6.42419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#008DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#FFAB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.1247b8ce6c8542c158e89a0726559d16.svg";
export { ForwardRef as ReactComponent };